import React, { Component } from 'react'
import '../styles/style.css'
import bmi from '../images/bmi.svg'
import logo from '../images/logo.svg'
import menu from '../images/menu.svg'
import play from '../images/play.svg'
import weight from '../images/weight.png'
import weightSmall from '../images/weightSmall.svg'
import info from '../images/info.svg'
import { getContentHeaders, getGetApi } from '../common/axiosConfig'
import apiUrls from '../common/apiUrls'
import { FRONT_END_NAME, PACK_NAME, parseObjectBeforeGet, SPS_COMBINED_IP, CHECK_GENERIC_SUBS_API_PARAM, APP_ID, APP_KEY, COUNTRY_CODE, OPERATOR, DEVICE_ID, CHANNEL } from '../common/constants'
import Loader from '../common/loader'
import Menu from '../common/menu'
import $ from 'jquery'
import PopupBottomSub from '../common/popupBottomSubscription'
import axios from 'axios';
import {saveAccessLogs} from '../common/axiosConfig'
class Home extends Component {

    constructor(props) {
        super(props);
        this.showBmiCalculator = this.showBmiCalculator.bind(this);
        this.showList = this.showList.bind(this);
        this.subscribeUser = this.subscribeUser.bind(this);

        this.state = {
            exerciseList: [],
            recentList: [],
            showLoader: false,
            showMenu: false,
            showSubAlert: false,
            showBottomPopup: false,
            message: '',
            submessage: '',
            heading: '',
            flag: '',
            button: '',
            showCross:false

        }
        //this.wrapperRef = React.createRef();
    }

    showLoader = () => {
        this.setState({ showLoader: true });
    }
    hideLoader = () => {
        this.setState({ showLoader: false });
    }

    componentDidMount() {
        this.getExercisesList();
        this.isUserSubscribed();
        saveAccessLogs("healthportal", "homepage", "homepage");
        
    }

    showBmiCalculator() {
        if (sessionStorage.getItem("isUserSubscribed") == "true") {
            this.props.history.push("/healthportal/BmiCalculator");
        } else {
            this.setState({ showSubAlert: true })
        }

    }

    showList(){
        if (sessionStorage.getItem("isUserSubscribed") == "true") {
            this.props.history.push(FRONT_END_NAME+"/mylist");
        } else {
            this.setState({ showSubAlert: true })
        }

    }


    openSubCategory = (exercise) => {
        sessionStorage["currentCategory"] = exercise.categoryName;
        sessionStorage["previewImageUrl3"]  = exercise["previewImageUrl3"];
        //this.props.history.push({ pathname: FRONT_END_NAME + "/subcat", state: { categoryId: exercise.categoryId, categoryName: exercise.categoryName } });
        if (sessionStorage.getItem("isUserSubscribed") == "true") {
            //debugger;
            this.props.history.push({ pathname: FRONT_END_NAME + "/subcat", state: { categoryId: exercise.categoryId, categoryName: exercise.categoryName } });
        } else {
            this.setState({ showSubAlert: true })
        }
    }

    playVideo = (item) => {
        //this.props.history.push({ pathname: FRONT_END_NAME + "/videoplay", state: { video: item } })
        if (sessionStorage.getItem("isUserSubscribed") == "true") {
            this.props.history.push({ pathname: FRONT_END_NAME + "/videoplay", state: { video: item } })
        } else {
            this.setState({ showSubAlert: true })
        }

    }

    
    openMenu = () =>{
        //this.setState({showMenu:true});
        $("#menuComp").show();
    }
    


    handleClickOutside(event) {
        //debugger;
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            //   alert('You clicked outside of me!');
            this.hideMenu();
        }
    }

    setWrapperRef = (node) => {
        this.wrapperRef = node;

    }


    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    getExercisesList = () =>{
        this.showLoader();
        getGetApi(apiUrls.homepage, getContentHeaders()).then((response) => {
            if (response.data.code == 2000) {
                var exerciseList = response.data.data.categories[0].subCategories.filter((a) => { return (a.subCategoryName == "Middle Category") })[0].content3;
                var recentList = response.data.data.categories[0].subCategories.filter((a) => { return (a.subCategoryName == "Recent") })[0].content3;
                this.setState({ exerciseList, recentList });
                console.log("exerciseList", exerciseList);
                console.log("recentList", recentList);
                this.hideLoader();
            }
        })
    }


    isUserSubscribed=()=> {

        var userData = parseObjectBeforeGet("userdata");

        const headers = {
            'appid': APP_ID,
            'deviceId': DEVICE_ID,
            'operator': OPERATOR,
            'access_token': userData.profilerData.user.accessToken,
            'channel': CHANNEL,
            'msisdn': userData.profilerData.user.username,
            'appkey': APP_KEY,
            'countrycode': COUNTRY_CODE
        }

        var url = SPS_COMBINED_IP + CHECK_GENERIC_SUBS_API_PARAM;
        url = url.replace("<xxmsisdn>", userData.profilerData.user.username)
        url = url.replace("<xxoperator>", OPERATOR)
        url = url.replace("<xxappKey>", APP_KEY)

        axios.get(url, { headers })
            .then(response => response.data)
            .then(data => {
                if (data && (data.code == 2000)) {
                    if (data.data.subscribedPack && data.data.subscribedPack.length > 0) {
                        console.log("User is subscribed!, allowed to move to required screen ")
                        sessionStorage.setItem("isUserSubscribed", "true")
                        return true;
                    } else {
                        console.log("PackName list is not availble")
                        sessionStorage.setItem("isUserSubscribed", "false")
                        this.setState({showSubAlert:true})
                        sessionStorage.setItem("packname",data.data.notSubscribedPack[0].packName);
                        return false;
                    }
                } else if(data && (data.code == 2004)){

                    if(data.data.subscribtionStatusCode == 1){
                        sessionStorage.setItem("isUserSubscribed", "false")
                        this.setState({showSubAlert:true})
                         sessionStorage.setItem("packname",data.data.notSubscribedPack[0].packName);
                    }
                    else{
                        sessionStorage.setItem("isUserSubscribed", "true") 
                    }
                } else {
                    this.setState({
                        showErrorPopup: !this.state.showErrorPopup
                    })
                    sessionStorage.setItem("isUserSubscribed", "false")
                    return false;
                }
            })
            .catch(error => {
                return false;
            })
    }
    

     getMonthName(val) {
        var monthName = '';
        switch (val) {
            case '01': monthName = "Jan";
                break;
            case '02': monthName = "Feb";
                break;
            case '03': monthName = "Mar";
                break;
            case '04': monthName = "Ap";
                break;
            case '05': monthName = "May";
                break;
            case '06': monthName = "June";
                break;
            case '07': monthName = "July";
                break;
            case '08': monthName = "Aug";
                break;
            case '09': monthName = "Sep";
                break;
            case '10': monthName = "Oct";
                break;
            case '11': monthName = "Nov";
                break;
            case '12': monthName = "Dec";
                break;
        }
        return monthName;
    }

     getFormattedDate(date) {
         console.log(date);
        let dateTemp = date.split(' ')[0];
        console.log(dateTemp);
        let dateFetched = dateTemp.split('-');
        // console.log(dateTemp);
       
        var day = dateFetched[2];
        var monthName = this.getMonthName(dateFetched[1]);
        var year = dateFetched[0].split(' ')[0];

        return day + '-' + monthName + '-' + year;
    }

    subscribeUser() {
        this.showLoader();
        var userData = parseObjectBeforeGet("userdata");

        const headers = {
            'appid': APP_ID,
            'deviceId': DEVICE_ID,
            'operator': OPERATOR,
            'access_token': userData.profilerData.user.accessToken,
            'channel': CHANNEL,
            'msisdn': userData.profilerData.user.username,
            'appkey': APP_KEY,
            'countrycode': COUNTRY_CODE
        }


        var url = SPS_COMBINED_IP + "/v1/subscribeDirectBilling?packName=" +sessionStorage.getItem("packname")+
            "&appKey=" + APP_KEY + "&operator=" + OPERATOR + "&channel=" + CHANNEL + "&msisdn=" + userData.profilerData.user.username;

        axios.get(url, { headers })
            .then(response => response.data)
            .then(data => {
                this.hideLoader();
                console.log(data.code);
                if (data && (data.code == 2000)) {
                    console.log('==-=>> ' + data.data.subscribtionStatusCode);
                    if (data.data.subscribtionStatusCode == 0) {
                        sessionStorage.setItem("isUserSubscribed", "true");
                        this.setState({
                            showBottomPopup: true,
                            heading: "Congratulations!",
                            message: "You have successfully subscribed to MTN Health Portal.",
                            flag: "S",
                            submessage: "Validity: " +  this.getFormattedDate(data.data.subscribtionStartDate) + " to "+ this.getFormattedDate(data.data.subscribtionEndDate)+ ".",
                            button: "Ok",
                            showCross:false,
                        });
                    } else {
                        sessionStorage.setItem("isUserSubscribed", "false");
                        this.setState({
                            showBottomPopup: true,
                            heading: "Unable To Process",
                            message: "We are unable to process your request to to lower balance.",
                            flag: "E",
                            submessage: "Top up your account and try again",
                            button: "Ok",
                            showCross:false,
                        });
                    }
                }
                else {
                    sessionStorage.setItem("isUserSubscribed", "false");
                    this.setState({
                        showBottomPopup: true,
                        heading: "Unable To Process",
                        message: data.data.responseMessage,
                        flag: "E",
                        submessage: "Top up your account and try again",
                        button: "Ok",
                        showCross:false,
                    });
                }
                this.setState({ showSubAlert: false });
            })
    }


    unsubscribeUser() {
        //         URL :​ https://<domain>/SPSBilling/v1/initUnSubSM

        // Request Body : 
        // msisdn:<msisdn>:
        // countryCode : <>
        // validatedMsisdn : <boolean flag to check accesstoken validation required/notrequired>


        // Request Header
        // appkey : <unique key of app>
        // operator: <operator>
        // channel:<channel>
        // deviceId: <deviceId>
        // appid : <appid>
        // access_token : <access_token>
        // countryCode :<countryCode>
        // msisdn : <msisdn></msisdn>

        var userData = parseObjectBeforeGet("userdata");

        const headers = {
            'appid': APP_ID,
            'deviceId': DEVICE_ID,
            'operator': OPERATOR,
            'access_token': userData.profilerData.user.accessToken,
            'channel': CHANNEL,
            'msisdn': userData.profilerData.user.username,
            'appkey': APP_KEY,
            'countrycode': COUNTRY_CODE
        }

        const body = {
            'msisdn': userData.profilerData.user.username,
            'countryCode': COUNTRY_CODE,
            'validatedMsisdn': true
        }

        var url = SPS_COMBINED_IP + "/v1/initUnSubSM";

        axios.post(url, body, { headers })
            .then(response => response.data)
            .then(data => {

                console.log(data.code);
                if (data && (data.code == 2000)) {
                    sessionStorage.setItem("isUserSubscribed", "false");
                      
                    this.setState({
                        showBottomPopup: true,
                        heading: "Unsubscribed",
                        message: "You are unsubscribed.",
                        flag: "S",
                        submessage: "",
                        button: "Ok",                
                        showCross:false,
                    });
               
                }else{
                    this.setState({
                        showBottomPopup: true,
                        heading: "Error!",
                        message: "Error in operation.",
                        flag: "E",
                        submessage: "",
                        button: "Ok",
                        showCross:false,
         
                    });
                }
            });
            this.setState({showUnsubscribeUser:false})
    }


    closePopup(flag) {
        console.log(flag)

        if (flag == "Ok") {
            this.setState({
                showBottomPopup: false
            })
        } else {
            this.unsubscribeUser();
        }
    }

    showUnsubscribeUser() {
        this.setState({
            showMenu: false,
            showBottomPopup: true,
            heading: "Unsubscribe",
            message: "Are you sure that you wants to unsubscribe from the service.",
            flag: "A",
            submessage: "",
            showCross:true,
            button: "Unsubscribe"
        });

    }

    render() {
        let { message, heading, flag, showCross, submessage, exerciseList, button, recentList, showMenu, showBottomPopup } = this.state;
        return (
            <div className="container-home">
                <Menu  showUnsubscribeUser={this.showUnsubscribeUser.bind(this)}></Menu>
                {showBottomPopup ?
                    <PopupBottomSub button={button} heading={heading} message={message} flag={flag} submessage={submessage} showCross={showCross} closePopup={this.closePopup.bind(this)} />
                    : null}

               
                {this.state.showLoader && <Loader></Loader>}
                <div className="header-home">
                    <img src={menu} onClick={this.openMenu} ></img>
                    <img src={logo}></img>
                    <span>Mind & Body</span>
                </div>

                {this.state.showSubAlert ?
                    <div className="warning-div">
                        <div className="wd-left">
                            <div><img src={info}></img></div>
                            <div>
                                <p className="wd-bold">Sub Request</p>
                                <p className="wd-normal">You need to subscribe this service to
                                <br />Proceed further<br />
                                Charges : Weekly 1GHC
                            </p>
                            </div>
                        </div>
                        <div className="wd-right">
                            <button onClick={this.subscribeUser}>Pay</button>
                        </div>
                    </div>
                    : null}
                <div className="content-home">
                    <div className="options-home">
                        <div className="oh-left" onClick={this.showList}>
                            <div><img src={play}></img></div>
                            <div>
                                <p>My List</p>
                                <p className="wdd-normal">Saved Videos</p>
                            </div>
                        </div>
                        <div className="oh-right" onClick={this.showBmiCalculator}>
                            <div><img src={bmi}></img></div>
                            <div>
                                <p>BMI</p>
                                <p>Calculator</p>
                            </div>
                        </div>
                    </div>
                    <div className="categories">
                        {
                            exerciseList.map((exercise, index) => <div className="categories-div" key={index} onClick={() => { this.openSubCategory(exercise) }}>
                                <div className="pic-div">
                                    {/* <p className="categories-div-p"><img src={exercise.previewImageUrl2}></img></p> */}
                                    <img src={exercise.previewImageUrl}></img>
                                </div> 
                                <div className="hey">
                                    <p className="type">{exercise.categoryName}</p>
                                </div>
                            </div>
                            )}
                    </div>
                    <div className="recent">
                        <div className="recent-p">
                            <span>Recent Videos</span>
                            {/* <span>See All</span> */}
                        </div>
                        <div className="recent-list-n">
                            {
                                recentList.map((recent,index)=>
                                <div>
                                    <div className="recent-list-n-div" key={index} onClick={()=>{this.playVideo(recent)}} style={{backgroundImage:`url(${recent.videoPreviewImage})`}}></div>
                                    <p className="data-home-n">{recent.title}</p>
                                </div>   
                                )
                            }

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Home